<div id="labelinput" #labelinput [ngStyle]="stylish">
  <div class="labelinputtitle" [ngStyle]="labelstyle">{{ title }}</div>
  <div class="labelinputinput">
    <input
      [(ngModel)]="value"
      [type]="type"
      (change)="change()"
      (keyup)="change()"
      [disabled]="disabled"
    />
  </div>
</div>
